import React from 'react';
import PropTypes from 'prop-types';
import { Box, Text } from '@rsos/components/capstone/base';

/**
 * Sub-component of BasemapMenu - header for basemaps/addons.
 * @param {String} title - Basemaps/addons title
 */
const BasemapsAddonsHeader = ({ title }) => (
  <Box data-name="basemaps-addons-header">
    <Text
      color="primaryText"
      data-name="basemaps-addons-title"
      fontWeight="regular"
      marginBottom="8px"
      noWrap
      size="normal"
    >
      {title}
    </Text>
  </Box>
);

BasemapsAddonsHeader.propTypes = {
  title: PropTypes.string,
};

export default BasemapsAddonsHeader;
